import React from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { Box } from '@material-ui/core';

const ArrowDown = () => {
    return (
        <Box m={1}>
            <ArrowDownwardIcon color='primary' />
        </Box>
    );
};

export default ArrowDown;
